import { isValid, parseISO } from "date-fns";
import { calendarDateLabel } from "./caseReviewDateTime";

export type DatePrecision = "year" | "month" | "day";
export const DATE_PRECISION_LABELS: Record<DatePrecision, string> = {
  year: "Year", month: "Month & year", day: "Full date",
};
export const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function datePrecision(value: string): DatePrecision {
  return value.split("-").length === 3 ? "day" : value.includes("-") ? "month" : "year";
}
export function validPartialDate(value: string): boolean {
  if (!/^\d{4}(-\d{2}(-\d{2})?)?$/.test(value) || value.startsWith("0000")) return false;
  return isValid(parseISO(value));
}
export function partialDateLabel(value: string): string {
  if (!validPartialDate(value)) return value;
  const precision = datePrecision(value);
  const [year, month] = value.split("-");
  const label = precision === "day" ? calendarDateLabel(value)
    : precision === "month" ? `${MONTH_NAMES[Number(month) - 1]} ${year}` : year;
  return `${label} · ${DATE_PRECISION_LABELS[precision]}`;
}
